/* ============
 * Add multiple clients modal
 * ============
 *
 * This is the component for creating batch log
 */
import clientService from '../../services/client';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      clients: [],
      clientOptions: [],
      optionsLoading: false,
      subTitle: '',
      submitLoading: false,
    };
  },
  props: {
    selectedClients: {
      type: Array,
      required: true,
      default: () => [],
    },
    onSubmit: {
      type: Function,
      required: true,
      default: () => { },
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
  },

  computed: {

  },

  mounted() {
    this.clients = JSON.parse(JSON.stringify(this.selectedClients));
    if (this.type === 'activateClient') {
      this.subTitle = 'Activate Client';
    } else if (this.type === 'deactivateClient') {
      this.subTitle = 'Deactivate Client';
    } else if (this.type === 'isProducer') {
      this.subTitle = 'Producer';
    } else if (this.type === 'isSubClient') {
      this.subTitle = 'Sub Client';
    }
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    proceed() {
      let data = this.clients.map(item => item.id);
      if (this.type === 'isSubClient') {
        data = this.clients.map(item => ({
          id: item.id,
          bill_main_parent: item.billMainParent,
          client_parent_id: item.clientParentId,
        }));
      }

      this.submitLoading = true;
      clientService.bulkUpdate({ client_ids: Object.assign({}, data), type: this.type })
        .then(() => {
          this.submitLoading = false;
          this.$message({
            message: 'Selected client successfully update',
            type: 'success',
          });
          this.handleSubmit();
        });
    },

    onBillMainParent(value, id) {
      const objIndex = this.clients.findIndex((obj => obj.id === id));
      this.clients[objIndex].billMainParent = !!value;
    },

    onClientParent(value, id) {
      const objIndex = this.clients.findIndex((obj => obj.id === id));
      this.clients[objIndex].clientParentId = value;
    },

    searchMethod(search, id) {
      if (search !== '') {
        this.optionsLoading = true;
        clientService.all(search, id)
          .then((response) => {
            this.clientOptions = response.map(c => ({ value: c.id, label: c.name }));
            this.optionsLoading = false;
          });
      }
    },

    handleSubmit() {
      this.closeModal();
      this.onSubmit();
    },

    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    //
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkProcessClientModal/bulkProcessClientModal.js